import { PlusIcon } from 'lucide-react'
import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { useOrganizationViewUrl } from '../../../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../../../utils/routing/reactRoute'
import { BillsTableRow } from '../../../../types/billsTableRow'
import { BillsTableActionType } from '../../enums/billsTableActionType'
import { BillsTableAction } from '../../types/billsTableAction'

/**
 * @todo Handle localization
 * @see https://linear.app/shine-co/issue/EXP-357/web-add-localization
 */
export const useCreateCreditNoteAction = (row: BillsTableRow): BillsTableAction => {
  const navigate = useNavigate()
  const location = useLocation()
  const { url: createCreditNoteUrl } = useOrganizationViewUrl(
    reactRoute.organization.bills.getCreateCreditNoteRoute(row.id),
  )

  const navigateToCreateCreditNote = useCallback(() => {
    if (!createCreditNoteUrl) {
      return
    }

    // Preserve the list's search params so the user lands back on the same filtered list
    navigate(`${createCreditNoteUrl}${location.search}`)
  }, [createCreditNoteUrl, location.search, navigate])

  return {
    type: BillsTableActionType.CreateCreditNote,
    label: 'Create credit note',
    icon: PlusIcon,
    onClick: navigateToCreateCreditNote,
  }
}
